import React, { Fragment, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import Content from './components/content/content.component'
import { Container } from './styles.style'
import { toastActions } from '../../actions'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { MuvicardProposalValidationPage as ProposalValidation } from './components/muvicard-proposal-validation/muvicard-proposal-validation.page'

const MuvicardRegisterPage = props => {
	const { user, toastError, toastSuccess, hideLoading, showLoading } = props
	const [proposalAccepted, setProposalAccepted] = useState(false)
	const [redirectToSteps, setRedirectToSteps] = useState(false)

	const handleAcceptProposal = () => {
		setProposalAccepted(true)
		setRedirectToSteps(true)
	}
	return (
		<Fragment>
			{!redirectToSteps ? (
				<ProposalValidation
					user={user}
					proposalAccepted={proposalAccepted}
					onAcceptProposal={handleAcceptProposal}
				/>
			) : (
				<Container logged={user}>
					<Content
						toastError={toastError}
						toastSuccess={toastSuccess}
						hideLoading={hideLoading}
						showLoading={showLoading}
						user={user}
					/>
				</Container>
			)}
		</Fragment>
	)
}

const mapStateToProps = store => ({
	user: store.user
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading
		},
		dispatch
	)

const connectedMuvicardRegisterPage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(MuvicardRegisterPage)
)
export { connectedMuvicardRegisterPage as ModuleRootComponent }
